




import {Component, Prop, Vue} from 'vue-property-decorator';
import IconClose from '@/components/icons/IconClose.vue';

@Component({
	components: {
		IconClose,
	},
})
export default class CloseButton extends Vue {
	@Prop({default: true})
	show!: boolean;
}
